<template>
  <div>
    <div v-if="!peaDeleted && peaExists">
      <pea-summary ref="peaSummary" :peaId="mainPeaId" :disabled="disableEditing" :canReopenPEA="canReopenPEA"  @updateYears="updateYears" @reopened="refreshSections"></pea-summary>
      <br />
      <pea-status-history ref="peaStatusHistory" :peaId="mainPeaId"></pea-status-history>
      <br />
      <pea-financial-assets ref="peaFinancialAssets" v-on:peaFAClassChange="determinePeaCheckLegalStatus"  :peaId="mainPeaId" :disabled="disableEditing" :startingYear="startingYear"></pea-financial-assets>
      <br />
      <pea-cri ref="peaCRI" :peaId="mainPeaId" :disabled="disableEditing" :disableButton="disableCRIDocuments"></pea-cri>
      <br />
      <pea-documents ref="peaDocuments" :peaId="mainPeaId" :disabled="disableCostingAndJustificationDocuments"></pea-documents>
      <br />
      <pea-financial-summary ref="peaFinancialSummary" :peaId="mainPeaId" :disabled="disableFinancialSummary" :canEditCostToDate="canEditCostToDate" :isCompleting="isCompleting"></pea-financial-summary>
      <br />
      <pea-check ref="peaCheck" :peaId="mainPeaId" :disabled="disableEditing"></pea-check>
      <br />
      <!--<pea-authorization-preview  ref="peaAuthorizationPreview" :peaId="mainPeaId"></pea-authorization-preview>-->
      <pea-authorization ref="peaAuthorization" :peaId="mainPeaId" :canEditPea="canEditPEA" :isApprover="isApprover"></pea-authorization>
      <br />
      <pea-comment ref="peaComment" :peaId="mainPeaId" ></pea-comment>
      <br />

      <br />
      <div v-if="isLoading">
        Submit Processing...
      </div>
      <el-alert v-if="alertTitle !== ''"
        :title="alertTitle"
        :type="alertType"
        :description="callInfo"
        :closable="false"
        show-icon>
      </el-alert>
      <pea-statusworkflow ref="peaStatusWorkflow" :peaId="mainPeaId" :canEditFullPea="this.canEditPEA" :canEditPartialPea="this.canEditPartialPEA" :isApprover="this.isApprover" :canApprovePEA="this.canApprovePEA" :canUserWithdrawPea="this.canWithdrawPEA" v-on:save="save('', '')" v-on:updateWorkflow="updateWorkflow"></pea-statusworkflow>
    </div>
    <div v-if="peaDeleted">
      PEA {{this.mainPeaId}} has been deleted and cannot be viewed.
    </div>
    <div v-if="!peaExists">
      PEA {{this.mainPeaId}} does not exist.
    </div>
  </div>
</template>

<script>
import router from '../router'
import helperMethods from '@/components/utility/helperMethods.js'
export default {
  name: 'peaMain',
  props: [
    'peaId'
  ],
  data () {
    return {
      isLoading: false,
      callInfo: '',
      alertType: '',
      alertTitle: '',
      peaSummaryValidState: false,
      peaFinancialSummaryValidState: false,
      peaFinancialAssetValidState: false,
      peaDocumentValidState: false,
      mainPeaId: this.peaId,
      disableEditing: true,
      canEditPEA: false,
      canReopenPEA: false,
      canEditPartialPEA: false,
      isApprover: false,
      canApprovePEA: false,
      canWithdrawPEA: false,
      disableFinancialSummary: true,
      disableCRI: true,
      disableCRIDocuments: true,
      disableCostingAndJustificationDocuments: true,
      canEditCostToDate: false,
      startingYear: new Date().getFullYear(),
      peaDeleted: false,
      peaExists: true,
      newStatusId: 0
    }
  },
  created: function () {
    this.$on('peaSummaryValidation', function (value) {
      this.peaSummaryValidState = value
    })
    this.$on('peaFinancialSummaryValidation', function (value) {
      this.peaFinancialSummaryValidState = value
    })
    this.$on('peaFinancialAssetValidation', function (value) {
      this.peaFinancialAssetValidState = value
    })
    this.$on('peaDocumentValidation', function (value) {
      this.peaDocumentValidState = value
    })
    this.startUp()
  },
  computed: {
    isCompleting () {
      return this.newStatusId === 4
    }
  },
  methods: {
    startUp () {
      this.setPermissions()
    },
    updateYears () {
      this.startingYear = this.$refs.peaSummary.peaCore.projectStartDate.getFullYear()
    },
    determinePeaCheckLegalStatus () {
      var setLegal = false
      var setIT = false
      var itTotal = 0
      var i = 0
      // check if any capital assets have land or building as a classification
      for (i = 0; i < this.$refs.peaFinancialAssets.capitalAssets.length; i++) {
        var classification = this.$refs.peaFinancialAssets.capitalAssets[i].classification
        if (classification === 1 || classification === 4) {
          setLegal = true
        }
        if (classification === 2) {
          itTotal = itTotal + this.$refs.peaFinancialAssets.capitalAssets[i].totalAmount
        }
      }
      // check if any operating leases have land or building as a classification
      i = 0
      for (i = 0; i < this.$refs.peaFinancialAssets.operatingLeases.length; i++) {
        classification = this.$refs.peaFinancialAssets.operatingLeases[i].classification
        if (classification === 1 || classification === 4) {
          setLegal = true
        }
        if (classification === 2) {
          itTotal = itTotal + this.$refs.peaFinancialAssets.operatingLeases[i].totalAmount
        }
      }
      // check if any other Expenditures have land or building as a classification
      i = 0
      for (i = 0; i < this.$refs.peaFinancialAssets.otherExpenditures.length; i++) {
        classification = this.$refs.peaFinancialAssets.otherExpenditures[i].classification
        if (classification === 1 || classification === 4) {
          setLegal = true
        }
        if (classification === 2) {
          itTotal = itTotal + this.$refs.peaFinancialAssets.otherExpenditures[i].totalAmount
        }
      }

      if (itTotal >= 25000) {
        setIT = true
      }
      this.$refs.peaCheck.checkData[2].isRequired = setLegal
      this.$refs.peaCheck.checkData[1].isRequired = setIT
    },
    save (successHeader, successBody) {
      // catch multi clicks
      if (this.isLoading === true && this.newStatusId === 0) {
        return
      }
      this.isLoading = true
      return new Promise((resolve, reject) => {
        this.$refs.peaStatusWorkflow.updateLoading(true)
        this.callInfo = ''
        this.alertType = ''
        this.alertTitle = ''
        var valid = false
        // only need to save the cost to Date field, since its the only thing editable related to save button.
        // unless its completing or withdrawing
        if (this.canEditCostToDate && this.newStatusId !== 4 && this.newStatusId !== 11) {
          valid = this.checkFormValidation(true)
          if (valid) {
            const loading = this.$loading({
              lock: true,
              text: 'Processing',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            })
            setTimeout(() => {
              loading.close()
            }, 15000)
            if (this.newStatusId !== 0) {
              this.$refs.peaSummary.peaCore.peaStatusId = this.newStatusId
            }
            Promise.all([
              this.$refs.peaSummary.summaryFormSubmit(),
              this.$refs.peaDocuments.documentsFormSubmit(),
              this.$refs.peaFinancialSummary.updateFinancialSummary()
            ]).then(data => {
              this.$refs.peaStatusWorkflow.updateLoading(false)
              this.isLoading = false
              loading.close()
              if (successHeader !== '') {
                helperMethods.showNotification(this, successHeader, successBody, 'success', 10000)
              } else {
                helperMethods.showNotification(this, 'PEA Successfully Updated!', 'Update Success', 'success', 10000)
              }
              this.checkIE()
              this.$refs.peaStatusHistory.fetchData()
            }).catch(reject => {
              // errors thrown in individual components
              loading.close()
              this.$refs.peaStatusWorkflow.updateLoading(false)
              this.isLoading = false
            })
          }
        } else {
          // if user can't edit the PEA and the status is not changing to withdraw then throw an error to the user
          if (!(this.canEditPEA || this.canEditPartialPEA) && this.newStatusId !== 11) {
            helperMethods.showNotification(this, 'Not allowed to edit!', 'Edit Error', 'warning', 10000)
            return
          }
          valid = this.checkFormValidation(false)
          if (valid) {
            const loading = this.$loading({
              lock: true,
              text: 'Processing',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            })
            setTimeout(() => {
              loading.close()
            }, 15000)
            if (this.newStatusId !== 0) {
              this.$refs.peaSummary.peaCore.peaStatusId = this.newStatusId
              this.newStatusId = 0
            }
            // change from created to inpreparation in case status inadvertantly is created after initial save
            if (this.$refs.peaSummary.peaCore.peaStatusId === 1) {
              this.$refs.peaSummary.peaCore.peaStatusId = 5
            }
            // updatefinancialassets called first then updatefinancialsummary, then summaryformsubmit and then the others
            this.$refs.peaFinancialAssets.updateFinancialAssets().then(data => {
              this.$refs.peaFinancialSummary.updateFinancialSummary().then(data => {
                this.$refs.peaCheck.updatePEAChecks().then(data => {
                  this.$refs.peaSummary.summaryFormSubmit().then(data => {
                    Promise.all([
                      this.$refs.peaCRI.updateCRI(),
                      this.$refs.peaDocuments.documentsFormSubmit()
                    ]).then(data => {
                      loading.close()
                      this.$refs.peaStatusWorkflow.updateLoading(false)
                      this.isLoading = false
                      if (successHeader !== '') {
                        helperMethods.showNotification(this, successHeader, successBody, 'success', 10000)
                      } else {
                        helperMethods.showNotification(this, 'PEA Successfully Updated!', 'Update Success', 'success', 10000)
                      }
                      this.checkIE()
                      // refresh history table, authorization table, and summary for Status refresh after a status change
                      this.refreshSections()
                    }).catch(reject => {
                      loading.close()
                      // errors thrown in individual components
                      this.$refs.peaStatusWorkflow.updateLoading(false)
                      this.isLoading = false
                    })
                  }).catch(reject => {
                    loading.close()
                    // errors thrown in individual components
                    this.$refs.peaStatusWorkflow.updateLoading(false)
                    this.isLoading = false
                  })
                }).catch(reject => {
                  loading.close()
                  // errors thrown in individual components
                  this.$refs.peaStatusWorkflow.updateLoading(false)
                  this.isLoading = false
                })
              }).catch(reject => {
                loading.close()
                // errors thrown in individual components
                this.$refs.peaStatusWorkflow.updateLoading(false)
                this.isLoading = false
              })
            }).catch(reject => {
              loading.close()
              // errors thrown in individual components
              this.$refs.peaStatusWorkflow.updateLoading(false)
              this.isLoading = false
            })
          }
        }
        this.newStatusId = 0
      })
    },
    checkIE () {
      var browser = helperMethods.getBrowser()
      if (browser.name === 'MSIE' || browser.name === 'IE') {
        window.location.reload(true)
      }
    },
    checkFormValidation (short) {
      if (!short) {
        if (this.$refs.peaSummary.peaCore.peaStatusId === 5) { // only check summary if in preparation
          this.$refs.peaSummary.checkSummaryValid()
          this.$refs.peaFinancialAssets.checkFormValidation()
          if (this.peaSummaryValidState === true && this.peaFinancialAssetValidState === true) {
            return true
          } else {
            this.isLoading = false
            this.$refs.peaStatusWorkflow.updateLoading(false)
            return false
          }
        } else if (this.newStatusId === 4) { // only check financial summary if completing
          this.$refs.peaFinancialSummary.checkFinancialSummaryValid()
          if (this.peaFinancialSummaryValidState) {
            return true
          } else {
            this.isLoading = false
            this.$refs.peaStatusWorkflow.updateLoading(false)
            return false
          }
        } else {
          return true
        }
      } else {
        this.$refs.peaSummary.checkSummaryValid()
        this.$refs.peaFinancialAssets.checkFormValidation()
        this.$refs.peaDocuments.checkFormValidation()
        this.$refs.peaFinancialSummary.checkFinancialSummaryValid()
        if (this.peaSummaryValidState === true && this.peaFinancialAssetValidState === true &&
            this.peaDocumentValidState === true && this.peaFinancialSummaryValidState === true) {
          return true
        } else {
          this.isLoading = false
          this.$refs.peaStatusWorkflow.updateLoading(false)
          return false
        }
      }
    },
    updateWorkflow (data) {
      // catch multi clicks
      if (this.isLoading === true) {
        return
      }
      this.$refs.peaStatusWorkflow.updateLoading(true)
      this.isLoading = true
      let call = ''
      let successHeader = ''
      let successBody = ''
      let errorHeader = ''
      let postData = { comment: data.comment }
      let needSave = false
      let needRefresh = false
      let updateWorkflow = true
      this.newStatusId = 0
      switch (data.newstatus) {
        case 'submit':
          this.newStatusId = 2
          this.save('', '')
          return
        case 'resubmit':
          // status of 6 = RAISED
          this.newStatusId = 6
          call = '/resubmitPEA/' + this.peaId
          successHeader = 'Resubmitted!'
          successBody = 'Your PEA has been resubmitted.'
          errorHeader = 'Error resubmitting PEA'
          needSave = true
          needRefresh = false
          break
        case 'approve':
          call = '/approvePEA/' + this.peaId
          successHeader = 'Approved!'
          successBody = 'Your approval has been saved.'
          errorHeader = 'Error approving PEA'
          needSave = false
          needRefresh = true
          break
        case 'deny':
          call = '/denyPea/' + this.peaId
          successHeader = 'Denied!'
          successBody = 'Your denial has been saved.'
          errorHeader = 'Error denying PEA'
          needSave = false
          needRefresh = true
          break
        case 'denyWithConditions':
          call = '/denyPeaWithConditions/' + this.peaId
          successHeader = 'Denied with conditions!'
          successBody = 'Your denial with conditions has been saved.'
          errorHeader = 'Error denying PEA with conditions'
          needSave = false
          needRefresh = true
          break
        case 'withdraw':
          this.newStatusId = 11
          updateWorkflow = false
          successHeader = 'Withdrawn!'
          successBody = 'Your withdrawal has been saved.'
          this.save(successHeader, successBody).then(data => {
            this.refreshSections()
          })
          return
        case 'cancel':
          call = '/cancelPea/' + this.peaId
          successHeader = 'Cancelled!'
          successBody = 'Your cancellation has been saved.'
          errorHeader = 'Error cancelling PEA'
          needSave = false
          needRefresh = true
          break
        case 'complete':
          this.newStatusId = 4
          updateWorkflow = false
          successHeader = 'Complete!'
          successBody = 'Your PEA has been marked completed.'
          this.$nextTick(() =>
            this.save(successHeader, successBody).then(data => {
              this.refreshSections()
            }))
          return
        case 'delete':
          updateWorkflow = false
          this.$refs.peaSummary.peaCore.peaStatusId = 13
          this.$refs.peaSummary.summaryFormSubmit().then(data => {
            helperMethods.showNotification(this, 'PEA ' + this.mainPeaId + ' is deleted!', 'PEA ' + this.mainPeaId + ' can no longer be viewed.', 'error', 10000)
            router.push('/')
          })
          return
      }
      if (updateWorkflow) {
        // still check validation first
        var shortForm = false
        if (this.canEditCostToDate && this.$refs.peaSummary.peaCore.peaStatusId !== 4 && this.$refs.peaSummary.peaCore.peaStatusId !== 11) {
          shortForm = true
        }
        var valid = this.checkFormValidation(shortForm)
        if (valid) {
          this.updateWorkflowStatusCall(call, successHeader, successBody, errorHeader, postData).then(data => {
            if (needSave) {
              this.save(successHeader, successBody)
            }
            if (!needSave && needRefresh) {
              helperMethods.showNotification(this, successHeader, successBody, 'success', 10000)
            }
            if (needRefresh) {
              this.checkIE()
              this.refreshSections()
            }
          }).catch(reject => {
            // errors thrown in individual components
            this.$refs.peaStatusWorkflow.updateLoading(false)
            this.isLoading = false
          })
        }
      }
    },
    setPermissions () {
      var call = '/canUserEditPEA/' + this.mainPeaId
      var secondCall = '/getPEAStatusCheck/' + this.mainPeaId
      this.$axios.get(call).then(response => {
        const dto = response.data
        if (dto.peaIsDeleted) {
          this.peaDeleted = true
          this.$refs.peaSummary.setPEADelete()
          helperMethods.showNotification(this, 'PEA ' + this.mainPeaId + ' is deleted!', 'PEA ' + this.mainPeaId + ' cannot be viewed.', 'error', 30000)
          router.push('/')
        }
        this.disableEditing = !dto.canEditFullPEA

        this.canEditPartialPEA = dto.canEditFinancialSummaryPEA || dto.canEditDocumentsPEA || dto.canEditCRIPEA || dto.canEditCostToDate

        this.disableFinancialSummary = !dto.canEditFinancialSummaryPEA
        this.disableCRIDocuments = !dto.canEditDocumentsPEA
        this.disableCRI = !dto.canEditCRIPEA
        this.disableCostingAndJustificationDocuments = !dto.canEditDocumentsPEA
        this.canEditCostToDate = dto.canEditCostToDate
        this.canWithdrawPEA = dto.canWithdrawPEA
        this.canEditPEA = dto.canEditFullPEA
        this.canReopenPEA = dto.canReopenPEA
        this.isApprover = dto.isPEAApprover
        this.canApprovePEA = dto.canApprovePEA
        return this.$axios.get(secondCall)
      }).then(response => {
        if (response.data.peaStatus === 'Submitted' || response.data.peaStatus === 'Partially Approved' || response.data.peaStatus === 'Complete' || response.data.peaStatus === 'Raised' || response.data.peaStatus === 'Approved' || response.data.peaStatus === 'Updated' || response.data.peaStatus === 'Pending Notification') {
          this.disableCostingAndJustificationDocuments = true
        }
      }).catch(response => {
        if (response.body.indexOf('PEA not found') !== -1) {
          this.peaExists = false
          this.$refs.peaSummary.setPEADelete()
          helperMethods.showNotification(this, 'PEA ' + this.mainPeaId + ' does not Exist!', 'PEA ' + this.mainPeaId + ' cannot be viewed.', 'error', 30000)
          router.push('/')
        } else {
          helperMethods.showNotification(this, 'Error getting PEA Permission', response.body, 'error', 30000)
        }
      })
    },
    refreshSections () {
      this.setPermissions()
      this.$refs.peaStatusHistory.fetchData()
      this.$refs.peaAuthorization.fetchData()
      this.$refs.peaStatusWorkflow.fetchData()
      this.$refs.peaSummary.fetchData()
      this.$refs.peaStatusWorkflow.updateLoading(false)
      this.isLoading = false
    },
    updateWorkflowStatusCall (call, successHeader, successBody, errorHeader, postData) {
      return new Promise((resolve, reject) => {
        this.$axios.post(call, postData).then(response => {
          resolve(response)
        })
          .catch(response => {
            helperMethods.showNotification(this, errorHeader, response.body, 'error', 30000)
            reject(response)
          })
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
